import { VersionHistory } from '@/components/shared/VersionHistory';
import { useDrawerWidths } from '@/hooks/useDrawerWidths';
import { useNavbarHeight } from '@/hooks/useNavbarHeight';
import Drawer from '@mui/material/Drawer';
import { EmptyStatePlaceholder } from '@/components/Analysis/shared/EmptyStatePlaceholder';
import { Stack } from '@mui/material';
import { primary } from '@/theme/colors';

type VersionsProps = {
  structureId: string;
  collectionName: string;
  referenceId?: string;
  onClose?: () => void;
  isESVersion?: boolean;
};

export const VersionsDrawer = ({
  structureId,
  collectionName,
  referenceId,
  isESVersion = false,
  onClose = () => {},
}: VersionsProps) => {
  const { rightDrawerWidth } = useDrawerWidths();
  const navbarHeight = useNavbarHeight();

  return (
    <Drawer
      sx={{
        width: rightDrawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: rightDrawerWidth,
          boxSizing: 'border-box',
          position: 'absolute',
          height: `calc(100vh - ${navbarHeight}px)`,
          backgroundColor: primary.TintedBlue,
          top: `${navbarHeight}px`,
          border: 0,
        },
      }}
      variant="permanent"
      anchor="right"
    >
      {!referenceId && (
        <Stack justifyContent="center" height="100vh">
          <EmptyStatePlaceholder type="version" />
        </Stack>
      )}
      {referenceId && (
        <VersionHistory
          structureId={structureId}
          collectionName={collectionName}
          referenceId={referenceId}
          onClose={onClose}
          isESVersion={isESVersion}
        />
      )}
    </Drawer>
  );
};
